<template>
  <div>
    <div class="row">
      <div class="small-12 medium-4 columns">
        <label>Starting at what age?</label>
      </div>

      <div class="medium-6 columns">
        <slider :property="PartTimeWorkFromAge" @update="setPartTimeWorkFromAge($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input type="number" :property="PartTimeWorkFromAge" @change="setPartTimeWorkFromAge"></custom-input>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-4 columns">
        <label>For how many years?</label>
      </div>

      <div class="medium-6 columns">
        <slider :property="PartTimeWorkYearsDuration" @update="setPartTimeWorkYearsDuration($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input type="number" :property="PartTimeWorkYearsDuration" @change="setPartTimeWorkYearsDuration"></custom-input>
      </div>
    </div>

    <div class="row">
      <div class="small-12 medium-4 columns">
        <label>How many days a week will you work? <help-icon message="If you plan on taking a career break set to 0 days. If you plan on working reduced hours provide your answer to the nearest half day."></help-icon></label>
      </div>

      <div class="medium-6 columns">
        <slider :property="PartTimeWorkDaysPerWeek" @update="setPartTimeWorkDaysPerWeek($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input type="number" :property="PartTimeWorkDaysPerWeek" @change="setPartTimeWorkDaysPerWeek"></custom-input>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    modifier: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['inputs']),
    PartTimeWorkFromAge() {
      return this.inputs[`PartTimeWorkFromAge${this.modifier}`];
    },
    PartTimeWorkYearsDuration() {
      return this.inputs[`PartTimeWorkYearsDuration${this.modifier}`];
    },
    PartTimeWorkDaysPerWeek() {
      return this.inputs[`PartTimeWorkDaysPerWeek${this.modifier}`];
    },
  },
  methods: {
    ...mapActions([
      'actionPartTimeWorkFromAge',
      'actionPartTimeWorkYearsDuration',
      'actionPartTimeWorkDaysPerWeek',
    ]),
    setPartTimeWorkFromAge(value) {
      this.actionPartTimeWorkFromAge({ value, modifier: this.modifier });
    },
    setPartTimeWorkYearsDuration(value) {
      this.actionPartTimeWorkYearsDuration({ value, modifier: this.modifier });
    },
    setPartTimeWorkDaysPerWeek(value) {
      this.actionPartTimeWorkDaysPerWeek({ value, modifier: this.modifier });
    },
  },
};
</script>
